module.exports = __webpack_public_path__ + "static/media/templeOutside.69f7566f.jpg";